import { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import './index.scss'

import AppHeader from '../../components/Header'
import AppFooter from '../../components/Footer'

import { APPCONFIG } from '../../configs/app'
import HOMECONFIG from '../../configs/home'
import ABOUTCONFIG from '../../configs/about'
import PRODUCTCONFIG from '../../configs/product'
import NEWSCONFIG from '../../configs/news'

import SwiperCore, { Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper.scss'
import 'swiper/components/pagination/pagination.scss'
SwiperCore.use([Autoplay])

class Home extends Component {

  state = {
    aboutInfo: [],
    newsInfo: []
  }

  componentDidMount () {
    let aboutInfo = JSON.parse(JSON.stringify(ABOUTCONFIG.info)).slice(1)
    for (let row = 0; row < aboutInfo.length; row++) {
      let element = aboutInfo[row]
      let obj = { en: '', cn: '' }
      for (let col = 0; col < element.content.length; col++) {
        const ele = element.content[col]
        if (ele.type === 'paragraph') {
          obj.en += ele.en
          obj.cn += ele.cn
        }
      }
      element.content = obj
    }

    let newsInfo = JSON.parse(JSON.stringify(NEWSCONFIG.info)).slice(0, 4)
    for (let row = 0; row < newsInfo.length; row++) {
      let element = newsInfo[row]
      element.image = ''
      let obj = { en: '', cn: '' }
      for (let col = 0; col < element.content.length; col++) {
        const ele = element.content[col]
        if (ele.type === 'paragraph') {
          obj.en += ele.en
          obj.cn += ele.cn
        } else if (ele.type === 'image' && !element.image) {
          element.image = ele.src
        }
      }
      element.content = obj
    }

    this.setState({ aboutInfo, newsInfo })
  }

  render () {
    let { lang } = this.props
    let { aboutInfo, newsInfo } = this.state
    let { name } = APPCONFIG
    let { swiper, video, footer } = HOMECONFIG
    return (
      <div className='app-page page-home'>
        <AppHeader />
        <div className='home-video background-image box'>
          <div className='box-content'>
            <Swiper
              style={{ height: '100%' }}
              loop
              autoplay={{ disableOnInteraction: false }}
            >
              {
                swiper.map((item, index) => {
                  return (
                    <SwiperSlide className='background-image' key={index} style={{ backgroundImage: `url(${item})` }}></SwiperSlide>
                  )
                })
              }
            </Swiper>
          </div>
          <div className='box-content flex-justify'>
            <div className='max-width flex-column-justify'>
              <div className='home-name'>{name[lang]}</div>
              <div className='flex'>
                <a className='video-button flex-align' href={video.link} target='_blank' rel='noreferrer'>
                  <div className='button-text flex-one'>{video.button[lang]}</div>
                  <div className='video-play background-image' style={{ backgroundImage: `url(${video.icon})` }}></div>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className='home-about flex-justify'>
          <div className='max-width flex-column-align'>
            <div className='about-title'>{ABOUTCONFIG.title[lang]}</div>
            <div className='about-introduction'>{ABOUTCONFIG.introduction[lang]}<Link className='introduction-more' to={{ pathname: '/about', state: { type: 0 } }}>{lang === 'cn' ? '更多' : 'More'}</Link></div>
            <div className='about-info flex'>
              {
                aboutInfo.map((item, index) => {
                  return (
                    <Link className='info-block flex-one' key={index} to={{ pathname: '/about', state: { type: index + 1 } }}>
                      <img className='block-image' src={item.image} alt={item.title[lang]}></img>
                      <div className='block-title'>{item.title[lang]}</div>
                      <div className='block-content two-line-ellipsis'>{item.content[lang].slice(0, 200)}</div>
                      <div className='flex flex-justify-end'>
                        <div className='block-more flex-align'>
                          <span>{lang === 'cn' ? '更多' : 'More'}</span>
                          <span className='iconfont icon-arrow-right'></span>
                        </div>
                      </div>
                    </Link>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='home-product flex-justify'>
          <div className='max-width flex-column-align'>
            <div className='product-title'>{PRODUCTCONFIG.title[lang]}</div>
            <div className='product-introduction'>{PRODUCTCONFIG.introduction[lang]}</div>
            <div className='product-info flex'>
              {
                PRODUCTCONFIG.info.map((item, index) => {
                  return (
                    <Link className='info-block flex-one' key={index} to={{ pathname: '/product', state: { type: index } }}>
                      <div className='block-image box'>
                        <div className='box-content'>
                          <div className='image-content background-image' style={{ backgroundImage: `url(${item.image})` }}></div>
                        </div>
                      </div>
                      <div className='block-title flex-align'>
                        <div className='flex-one'>{item.title[lang]}</div>
                        <div className='block-button box'>
                          <div className='box-content'>
                            <div className='button-icon background-image' style={{ backgroundImage: `url(${item.icon})` }}></div>
                          </div>
                        </div>
                      </div>
                    </Link>
                  )
                })
              }
            </div>
          </div>
        </div>
        <div className='home-news flex-justify'>
          <div className='max-width flex-column-align'>
            <div className='news-title'>{NEWSCONFIG.title[lang]}</div>
            <div className='news-info flex flex-wrap'>
              {
                newsInfo.map((item, index) => {
                  return (
                    <Link className='info-block flex-one' key={index} to={{ pathname: '/news/detail', state: { id: index } }}>
                      <div className='block-image box'>
                        <div className='box-content'>
                          <div className='image-content background-image' style={{ backgroundImage: `url(${item.image})` }}></div>
                        </div>
                      </div>
                      <div className='block-title one-line-ellipsis'>{item.title[lang] || item.title.cn}</div>
                      <div className='block-content two-line-ellipsis'>{(item.content[lang] || item.content.cn).slice(0, 100)}</div>
                    </Link>
                  )
                })
              }
            </div>
          </div>
        </div>
        <img className='footer-image' alt='' src={footer.background}></img>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default connect(mapStateToProps)(Home)
